// @ts-ignore
import { SlideYUpTransition, FadeTransition } from 'vue2-transitions'
import Vue from 'vue'

Vue.component('slide-y-up-transition', SlideYUpTransition)
Vue.component('fade-transition', FadeTransition)
